import { isUserReviewerForCustomer } from 'src/data/user';
import { useSelectedCustomerId } from 'src/store/customer/useSelectedCustomerId';

// @ts-expect-error - useCurrentUser has no TypeScript declarations
import useCurrentUser from './useCurrentUser';

export const useIsCurrentUserReviewer = (): boolean => {
  const user = useCurrentUser();
  const customerId = useSelectedCustomerId();

  return customerId !== null && isUserReviewerForCustomer(user, customerId);
};
